<template>
  <div class="loginContainer">
    <div class="loginContent">
      <div class="title">{{ title ? title : $t('lang.confirmWin.confirm') }}</div>
      <div class="body">
        <div class="text1" v-for="(text,index) in hintText" :key="index">{{ text }}</div>
        <div class="buttons">
          <div class="yes-btn" @click="yesClick">{{ okText ? okText : $t('lang.inviteFriends.ok') }}</div>
      </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'Confirm',
  props: ['confirmToDo', 'hintText', 'okText', 'title'],
  data () {
    return {
    }
  },
  methods: {
    yesClick () {
      if (this.confirmToDo) {
        this.confirmToDo()
      }
      this.$store.state.confirmWinShow = false
    },
    close () {
      this.$store.state.confirmWinShow = false
    }
  }
}
</script>

<style lang="less" scoped>
  .loginContainer {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0,0,0,.8);
    z-index: 10;
    .loginContent {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 86vw;
      height: max-content;
      transform: translate(-50%,-50%);
      .title {
        font-size: 6vw;
        line-height: 13vw;
        font-weight: bold;
        color: #543200;
        text-align: center;
        background: #F6D9AA;
        border-radius: 10px 10px 0 0;
      }
      .body {
        padding: 4.166vw 6.111vw;
        margin-bottom: 11.111vw;
        background: #212324;
        border-radius: 0 0 2.777vw 2.777vw;
        .text1 {
          margin: 0.5vw auto 3vw auto;
          font-size: 4.3vw;
          line-height: 5.833vw;
          color: #F6D9AA;
        }

        .buttons {
          display: flex;
          justify-content: center;
        }

        .yes-btn {
          margin: 1vw auto;
          background: #F6D9AA;
          border-radius: 1.666vw;
          text-align: center;
          color: #000D2E;
          font-size: 20px;
          width: 80vw;
          line-height: 11vw;
          height: 11vw;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ConfirmWin/Alert.vue